export const showDialog = (state, text) => {
    return {
        ...state,
        alertDialog: {
            open: true,
            text: text
        }
    }
}

export const hideDialog = state => {
    return {
        ...state,
        alertDialog: {
            open: false,
            text: ""
        }
    }
}
